import React from "react";
import images from "../constants/images";

const DailyCabsSection = () => {
  const cabOptions = [
    {
      title: "Pune ⇄ Mumbai Premium Cabs",
      desc: "Travel in style and comfort with Zab Travels. We offer punctual, clean, and safe rides between Pune and Mumbai — perfect for business trips, airport transfers, or weekend getaways.",
      img: images.punetomumbai,
      overlay: "Celebrity-approved journeys! Trusted by artists and professionals for premium Pune ⇄ Mumbai travel.",
      link: "/services"
    },
    {
      title: "Mumbai ⇄ Pune Luxury Cabs",
      desc: "Zab Travels brings you reliable and affordable rides from Mumbai to Pune. Whether it's early morning or late night, we’ve got you covered with experienced drivers and smooth rides.",
      img: images.mumbaitopune,
      overlay: "Experience the gold standard in travel — safe, on time, and stress-free journeys.",
      link: "/services"
    }
  ];

  return (
    <section className="py-12 mt-12">
      <div className="text-center mb-10">
        <h2 className="text-3xl md:text-4xl font-bold tracking-wide text-gray-800">
          PUNE ⇄ MUMBAI DAILY CABS
        </h2>
        <div className="w-16 h-1 bg-gradient-to-r from-yellow-300 via-yellow-400 to-yellow-500 mx-auto mt-2 rounded-full"></div>
      </div>

      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-8 px-4">
        {cabOptions.map((cab, idx) => (
          <div
            key={idx}
            className="bg-white shadow-lg rounded-lg overflow-hidden transform transition duration-300 hover:-translate-y-2 hover:shadow-2xl group"
          >
            <div className="relative overflow-hidden">
              <img
                src={cab.img}
                alt={cab.title}
                className="w-full h-96 object-cover transform transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 group-hover:bg-opacity-70 transition duration-300 p-4 text-white text-sm font-semibold">
                {cab.overlay}
              </div>
            </div>
            <div className="p-6 text-center">
              <h3 className="text-lg font-bold mb-2">{cab.title}</h3>
              <p className="text-gray-600 mb-4">{cab.desc}</p>
              <a
                href={cab.link}
                className="bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 text-white font-semibold px-6 py-3 rounded-full shadow hover:scale-105 transition duration-300 inline-block"
              >
                CHECK OUR CABS →
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default DailyCabsSection;
